import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './App.css';
import './index.css';

// Handle ResizeObserver error
const handleError = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    const resizeTimeout = setTimeout(() => {
      clearTimeout(resizeTimeout);
    }, 0);
    e.stopPropagation();
  }
};

window.addEventListener('error', handleError);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);